exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Page-root-Mq0Pg {\n  padding-left: 20px;\n  padding-right: 20px;\n  min-height: 50vh\n}\n\n.Page-container-jNnv9 {\n  margin: 0 auto;\n  padding: 0 0 40px;\n  max-width: var(--max-container-width);\n}\n\n@media screen and (max-width:1200px) {\n  .Page-container-jNnv9 {\n    padding: 85px 0 40px;\n  }\n}\n\n.Page-sectionTitle-1Q6dW {\n  font-size: 25px;\n  font-weight: 500;\n  margin-bottom: 20px;\n  color: var(--menu-color);\n  position: relative;\n  padding-bottom: 10px;\n}\n\n.Page-sectionTitle-1Q6dW::after {\n  content: '';\n  width: 40px;\n  height: 2px;\n  background: -webkit-gradient(linear, left top, right top, from(var(--menu-color)), to(var(--btn-primary-bg)));\n  background: linear-gradient(90deg, var(--menu-color), var(--btn-primary-bg));\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}", ""]);

// exports
exports.locals = {
	"root": "Page-root-Mq0Pg",
	"container": "Page-container-jNnv9",
	"sectionTitle": "Page-sectionTitle-1Q6dW"
};